// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__27WpA","colBig":"styles_colBig__3fGI5","colSmall":"styles_colSmall__r6M-G"};